var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profiles.length)?_c('span',[_c('icon-profile',{staticClass:"is-size-5"}),_vm._v(" "),_vm._l((_vm.profiles),function(profile){return _c('document-link',{key:profile.document_id,staticClass:"user-link-label",attrs:{"document":profile,"uppercase-first-letter":""}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }